import COMMON_ROUTE_PATHS from 'common/config/routes/route-paths';

const ROUTE_PATHS = {
  preload: '/authentication/:token',
  authenticationFaceActive: '/authentication/face/active/:can',
  error: '/authentication/error',
  login: '/authentication/login',
  ...COMMON_ROUTE_PATHS,
};

export default ROUTE_PATHS;
